import {handleAjaxError, throwMDBError, doNextStep} from 'src/wp-migrate-db-pro/asset/src/js/helpers/utils';

const $ = window.jQuery;
const wpmdb = window.wpmdb;
const ajaxurl = window.ajaxurl;

export default class ThemePluginFilesTransfer {

	getSelectedPluginsorThemes( themes_or_plugins ) {
		const items = $( `#select-${themes_or_plugins}` ).val();
		return items;
	}

	async doAJAX( args ) {
		const response = await $.ajax( {
			url: ajaxurl,
			type: 'POST',
			cache: false,
			data: args
		} );

		const parsed_response = JSON.parse( response );

		if ( 'undefined' !== typeof(parsed_response.wpmdb_error) ) {
			throwMDBError( parsed_response );
		}

		return parsed_response;
	}

	async initializeTransfer( themes_or_plugins ) {

		// This stops duplicated hooks from being added to the jQuery.wpmdb.hooks[ 'filter' ]['wpmdbmf_media_transfer_complete'] array item
		// i.e when _NOT_ reloading the page.
		// @TODO refactor usage of `wpmdbmf_media_transfer_complete` hook
		$.wpmdb.remove_action( 'wpmdbmf_media_transfer_complete' );

		const selected = this.getSelectedPluginsorThemes( themes_or_plugins );
		const excludes = $( '#file-ignores' ).val();

		const args = {
			action: 'wpmdb_initiate_file_migration',
			stage: themes_or_plugins,
			migration_state_id: wpmdb.migration_state_id,
			folders: JSON.stringify( selected ),
			excludes: JSON.stringify( excludes ),
			nonce: wpmdb_data.nonces.wpmdb_initiate_file_migration
		};

		try {
			const parsed_response = await this.doAJAX( args );
			return doNextStep( this.getQueueItems, [ themes_or_plugins, parsed_response ], this );
		} catch ( error ) {
			handleAjaxError( wpmdbtp_settings.strings.file_transfer_error, error );
		}
	}

	/**
	 *
	 * @param themes_or_plugins
	 * @param parsed_response
	 * @param offset
	 * @returns {Promise<*>}
	 */
	async getQueueItems( themes_or_plugins, parsed_response, offset = 0 ) {

		const args = {
			action: 'wpmdb_get_queue_items',
			stage: themes_or_plugins,
			offset: offset,
			migration_state_id: wpmdb.migration_state_id,
			nonce: wpmdb_data.nonces.wpmdb_get_queue_items
		};

		try {
			const parsed_response = await this.doAJAX( args );

			if ( 'complete' === parsed_response.status ) {
				return doNextStep( this.recursiveTransferFiles, [ themes_or_plugins, parsed_response ], this );
			}

			wpmdb.current_migration.setText( window.wpmdbtp_settings.strings.loading_transfer_queue );

			for ( var key in parsed_response.items ) {
				// skip loop if the property is from prototype
				if ( !parsed_response.items.hasOwnProperty( key ) ) {
					continue;
				}

				let item = parsed_response.items[ key ];
				const item_size = item.size / 1000;
				wpmdb.current_migration.model.addStageItem( themes_or_plugins, item.nice_name, item_size, null, item.nice_name );
			}

			return doNextStep( this.getQueueItems, [
				themes_or_plugins,
				parsed_response,
				parsed_response.offset
			], this );

		} catch ( error ) {
			handleAjaxError( wpmdbtp_settings.strings.file_transfer_error, error );
		}
	}

	/**
	 *
	 * @param stage
	 * @returns {Promise<any>}
	 */
	// @TODO probably filter batch_count somewhere
	async recursiveTransferFiles( stage ) {
		const args = {
			action: 'wpmdb_transfer_files',
			stage: stage,
			migration_state_id: wpmdb.migration_state_id,
			nonce: wpmdb_data.nonces.wpmdb_transfer_files
		};

		try {
			const parsed_response = await this.doAJAX( args );

			if ( 'complete' === parsed_response.status ) {
				wpmdb.current_migration.setText( ' ' );
				return this.determineNextStage( stage, parsed_response );
			}

			// Cascade update UI
			let timeout = 0;

			if ( parsed_response.hasOwnProperty( 'status' ) && 'undefined' !== typeof parsed_response.status.error ) {
				console.error( `Transfer error: ${parsed_response.status.message} ` );
				throw new Error( `${parsed_response.status.message}` );
			}

			for ( var key in parsed_response.status ) {

				if ( !parsed_response.status.hasOwnProperty( key ) ) {
					continue;
				}

				let item = parsed_response.status[ key ];

				if ( item.error ) {
					console.error( item );
				}

				wpmdb.current_migration.setText( window.wpmdbtp_settings.strings.current_transfer + item.nice_name );

				setTimeout( () => {
					wpmdb.current_migration
						.model
						.getStageModel( stage )
						.setItemPercentTransferred( item.nice_name, item.folder_percent_transferred, item.batch_size, item.folder_transferred );
				}, timeout );

				timeout += 40;
			}

			return doNextStep( this.recursiveTransferFiles, [ stage ], this );
		} catch ( error ) {
			handleAjaxError( wpmdbtp_settings.strings.file_transfer_error, error );
		}
	}

	determineNextStage( stage, parsed_response ) {
		let next = '';

		if ( 'themes' === stage && $( '#migrate_plugins' ).is( ':checked' ) ) {
			wpmdb.current_migration.model.setActiveStage( 'plugins' );

			next = doNextStep( this.initializeTransfer, [ 'plugins' ], this );

		} else if ( 'plugins' === stage || 'themes' === stage ) {
			//Handle complete
			if ( 'complete' === parsed_response.status ) {
				next = wpmdb.functions.wpmdb_call_next_hook();
			}
		}

		return next;
	}
}



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro-theme-plugin-files/asset/src/js/class/ThemePluginFilesTransfer.js